import { render, staticRenderFns } from "./order_pay_dialog.vue?vue&type=template&id=554f460c&scoped=true"
import script from "./order_pay_dialog.vue?vue&type=script&lang=js"
export * from "./order_pay_dialog.vue?vue&type=script&lang=js"
import style0 from "./order_pay_dialog.vue?vue&type=style&index=0&id=554f460c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "554f460c",
  null
  
)

export default component.exports